export default __webpack_public_path__ + "0bd8608b1f942c0e1819d7c083cc7038.svg";